module.exports = __webpack_public_path__ + "img/20200428_193536.ee74effb.jpg";